import { departments } from "data/authData";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import moment from "moment";

export const isNew = "is_new";
export const styleUrlKey = "style";
export const NAOption = "N/A";

export const styleFileUrlKey = "url";

export const fileTypes = {
	TECH_PACK: { name: "TECH PACK", key: "TECH_PACK" },
};

export const styleFileColumns = [
	{
		name: "Effective Date",
		key: "effective_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		default_value: moment().format("YYYY-MM-DD"),
	},
	{
		name: "File Name",
		key: "file_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
	{
		name: "File Type",
		key: "file_type",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		[selectOptionsKeyName]: { type: arrType, list: Object.values(fileTypes) },
	},
	{
		name: "URL",
		key: styleFileUrlKey,
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
];

export const styleImgDepartmentCol = {
	name: "Department",
	key: "department",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: false, DISPLAY: false, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	[selectOptionsKeyName]: { type: arrType, list: Object.values(departments) },
};

// Example: Column with API-based dropdown using data property
/*
export const exampleApiColumn = {
	name: "Supplier",
	key: "supplier",
	input_type: inputTypes.SELECT.key,  // or MULTIPLE_SELECT.key
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {
		use_api_dropdown: true,
		api_url: "/api/suppliers",
		store_value_as: "key"  // or "object"
	},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
};
*/
